export default "__VITE_ASSET__JT1ami8g__"